export default __webpack_public_path__ + "static/media/folk.d31bc6b5.png";